import { Chip } from '@components/std-components/Chip'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import moment from 'moment'
import React, { FC } from 'react'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import ChipListSkeleton from '@modules/order/components/CellLoaders/ChipListSkeleton/ChipListSkeleton'
import EnhancedCell from './EnhancedCell'

const EnhancedSalesPeriod: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    if (!rowData) {
      return (
        <div>
          <ChipListSkeleton count={1} />
        </div>
      )
    }

    const salesPeriodName = get(rowData, column.enhancedField)

    return (
      <EnhancedCell>
        {salesPeriodName ? (
          <Chip
            tooltip={`${salesPeriodName}\n${
              rowData?.['retailSalesPeriod-startDate']
                ? moment(new Date(rowData?.['retailSalesPeriod-startDate'])).format(
                    'DD-MMM-YYYY'
                  )
                : ''
            } to ${
              rowData?.['retailSalesPeriod-startDate']
                ? moment(new Date(rowData?.['retailSalesPeriod-endDate'])).format(
                    'DD-MMM-YYYY'
                  )
                : ''
            }`}
          >
            <Typography variant='caption' className={'salesPeriodText'}>
              {salesPeriodName}
            </Typography>
          </Chip>
        ) : (
          <Typography variant='caption'>{'NA'}</Typography>
        )}
      </EnhancedCell>
    )
  })

export default EnhancedSalesPeriod
